// import React, { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
// import { BiLogOut, BiSearch, BiRefresh } from "react-icons/bi";
// import SchoolReviewModal from "./SchoolReviewModal";

// const displayFont = { fontFamily: "'Fraunces', serif" };
// const bodyFont = { fontFamily: "'Sora', sans-serif" };

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// const STATUS_TABS = [
//   { key: "all", label: "All" },
//   { key: "pending", label: "Pending Review" },
//   { key: "approved", label: "Approved" },
//   { key: "rejected", label: "Rejected" },
// ];

// const statusBadge = {
//   pending: "bg-[#FFF4DE] text-[#B5760C] border border-[#F4D8A0]",
//   approved: "bg-[#E5F6EC] text-[#1E8A4C] border border-[#B9E6CB]",
//   rejected: "bg-[#FCEAEA] text-[#C23A3A] border border-[#F3C6C6]",
// };

// const authHeaders = () => ({
//   "Content-Type": "application/json",
//   Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
// });

// const AdminDashboard = () => {
//   const navigate = useNavigate();
//   const admin = JSON.parse(localStorage.getItem("adminInfo") || "{}");

//   const [stats, setStats] = useState({ total: 0, pending: 0, approved: 0, rejected: 0 });
//   const [schools, setSchools] = useState([]);
//   const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
//   const [activeTab, setActiveTab] = useState("pending");
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [selectedSchoolId, setSelectedSchoolId] = useState(null);

//   const handleAuthError = useCallback(() => {
//     localStorage.removeItem("adminToken");
//     localStorage.removeItem("adminInfo");
//     toast.error("Session expired, please sign in again");
//     navigate("/admin/login");
//   }, [navigate]);

//   const fetchStats = useCallback(async () => {
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/v1/admin/stats`, { headers: authHeaders() });
//       const data = await res.json();
//       if (res.status === 401 || res.status === 403) return handleAuthError();
//       if (data.success) setStats(data.stats);
//     } catch (error) {
//       console.error(error);
//     }
//   }, [handleAuthError]);

//   const fetchSchools = useCallback(async (page = 1) => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams({ status: activeTab, search, page, limit: 10 });
//       const res = await fetch(`${BACKEND_URL}/api/v1/admin/schools?${params}`, {
//         headers: authHeaders(),
//       });
//       const data = await res.json();
//       if (res.status === 401 || res.status === 403) return handleAuthError();
//       if (data.success) {
//         setSchools(data.schools);
//         setPagination({ page: data.pagination.page, totalPages: data.pagination.totalPages });
//       }
//     } catch (error) {
//       toast.error("Failed to load school registrations");
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab, search, handleAuthError]);

//   useEffect(() => {
//     fetchStats();
//   }, [fetchStats]);

//   useEffect(() => {
//     const timeout = setTimeout(() => fetchSchools(1), 300); // debounce search
//     return () => clearTimeout(timeout);
//   }, [fetchSchools]);

//   const refreshAll = () => {
//     fetchStats();
//     fetchSchools(pagination.page);
//   };

//   const logout = () => {
//     localStorage.removeItem("adminToken");
//     localStorage.removeItem("adminInfo");
//     navigate("/admin/login");
//   };

//   return (
//     <div className="min-h-screen w-full bg-[#F5F8FC]" style={bodyFont}>
//       <div className="bg-white border-b border-[#EDF1F7] sticky top-0 z-20">
//         <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
//           <div>
//             <h1 style={displayFont} className="text-xl text-[#101826]">
//               Eduvantra Admin Console
//             </h1>
//             <p className="text-xs text-[#5A6478]">School registration & approvals</p>
//           </div>
//           <div className="flex items-center gap-4">
//             <span className="text-sm text-[#5A6478]">{admin?.name}</span>
//             <button
//               onClick={logout}
//               className="flex items-center gap-1.5 text-sm text-[#C23A3A] hover:text-[#9c2f2f] transition-colors"
//             >
//               <BiLogOut /> Logout
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-6 py-8">
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
//           {[
//             { label: "Total Registrations", value: stats.total, color: "#163863" },
//             { label: "Pending Review", value: stats.pending, color: "#B5760C" },
//             { label: "Approved", value: stats.approved, color: "#1E8A4C" },
//             { label: "Rejected", value: stats.rejected, color: "#C23A3A" },
//           ].map((card) => (
//             <div
//               key={card.label}
//               className="bg-white rounded-2xl border border-[#EDF1F7] p-5 shadow-[0_1px_2px_rgba(16,24,38,0.04)]"
//             >
//               <p className="text-xs text-[#5A6478] mb-2">{card.label}</p>
//               <p style={{ ...displayFont, color: card.color }} className="text-3xl">
//                 {card.value}
//               </p>
//             </div>
//           ))}
//         </div>

//         <div className="bg-white rounded-2xl border border-[#EDF1F7] p-4 mb-6">
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
//             <div className="flex flex-wrap gap-2">
//               {STATUS_TABS.map((tab) => (
//                 <button
//                   key={tab.key}
//                   onClick={() => setActiveTab(tab.key)}
//                   className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
//                     activeTab === tab.key
//                       ? "bg-[#163863] text-white"
//                       : "bg-[#F5F8FC] text-[#5A6478] hover:bg-[#EEF3FC]"
//                   }`}
//                 >
//                   {tab.label}
//                   {tab.key === "pending" && stats.pending > 0 && (
//                     <span className="ml-1.5 inline-flex items-center justify-center text-[11px] bg-[#E8A63C] text-white rounded-full w-4 h-4">
//                       {stats.pending}
//                     </span>
//                   )}
//                 </button>
//               ))}
//             </div>

//             <div className="flex items-center gap-2">
//               <div className="relative">
//                 <BiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A6AFBD]" />
//                 <input
//                   type="text"
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   placeholder="Search by name, school ID, email, city..."
//                   className="pl-9 pr-4 py-2 w-72 bg-white border border-[#E3E8F0] rounded-full text-sm outline-none focus:border-[#2E63B8] focus:shadow-[0_0_0_4px_rgba(46,99,184,0.12)] transition-all"
//                 />
//               </div>
//               <button
//                 onClick={refreshAll}
//                 title="Refresh"
//                 className="w-9 h-9 flex items-center justify-center rounded-full border border-[#E3E8F0] text-[#5A6478] hover:bg-[#F5F8FC] transition-colors"
//               >
//                 <BiRefresh className="text-lg" />
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl border border-[#EDF1F7] overflow-hidden">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="bg-[#F8FAFD] text-left text-[#5A6478] text-xs uppercase tracking-wide">
//                 <th className="px-5 py-3 font-medium">School</th>
//                 <th className="px-5 py-3 font-medium">School ID</th>
//                 <th className="px-5 py-3 font-medium">Location</th>
//                 <th className="px-5 py-3 font-medium">Submitted</th>
//                 <th className="px-5 py-3 font-medium">Status</th>
//                 <th className="px-5 py-3 font-medium text-right">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan={6} className="px-5 py-10 text-center text-[#A6AFBD]">
//                     Loading registrations...
//                   </td>
//                 </tr>
//               ) : schools.length === 0 ? (
//                 <tr>
//                   <td colSpan={6} className="px-5 py-10 text-center text-[#A6AFBD]">
//                     No registrations found
//                   </td>
//                 </tr>
//               ) : (
//                 schools.map((school) => (
//                   <tr
//                     key={school._id}
//                     className="border-t border-[#EDF1F7] hover:bg-[#F8FAFD] transition-colors"
//                   >
//                     <td className="px-5 py-3.5">
//                       <p className="text-[#101826] font-medium">{school.name}</p>
//                       <p className="text-xs text-[#A6AFBD]">{school.email}</p>
//                     </td>
//                     <td className="px-5 py-3.5 text-[#5A6478]">{school.schoolId}</td>
//                     <td className="px-5 py-3.5 text-[#5A6478]">
//                       {school.city}, {school.state}
//                     </td>
//                     <td className="px-5 py-3.5 text-[#5A6478]">
//                       {new Date(school.createdAt).toLocaleDateString("en-IN", {
//                         day: "2-digit", month: "short", year: "numeric",
//                       })}
//                     </td>
//                     <td className="px-5 py-3.5">
//                       <span className={`px-2.5 py-1 rounded-full text-xs font-medium capitalize ${statusBadge[school.status]}`}>
//                         {school.status}
//                       </span>
//                     </td>
//                     <td className="px-5 py-3.5 text-right">
//                       <button
//                         onClick={() => setSelectedSchoolId(school._id)}
//                         className="px-4 py-1.5 rounded-full border border-[#2E63B8] text-[#2E63B8] text-xs font-semibold hover:bg-[#2E63B8] hover:text-white transition-colors"
//                       >
//                         Review
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {pagination.totalPages > 1 && (
//           <div className="flex justify-center gap-2 mt-6">
//             {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((p) => (
//               <button
//                 key={p}
//                 onClick={() => fetchSchools(p)}
//                 className={`w-8 h-8 rounded-full text-sm ${
//                   pagination.page === p
//                     ? "bg-[#163863] text-white"
//                     : "bg-white border border-[#E3E8F0] text-[#5A6478] hover:bg-[#F5F8FC]"
//                 }`}
//               >
//                 {p}
//               </button>
//             ))}
//           </div>
//         )}
//       </div>

//       {selectedSchoolId && (
//         <SchoolReviewModal
//           schoolId={selectedSchoolId}
//           onClose={() => setSelectedSchoolId(null)}
//           onActionComplete={() => {
//             setSelectedSchoolId(null);
//             refreshAll();
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default AdminDashboard;


import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { BiLogOut, BiSearch, BiRefresh } from "react-icons/bi";
import SchoolReviewModal from "./SchoolReviewModal";

const displayFont = { fontFamily: "'Fraunces', serif" };
const bodyFont = { fontFamily: "'Sora', sans-serif" };

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "pending", label: "Pending Review" },
  { key: "approved", label: "Approved" },
  { key: "suspended", label: "Suspended" },
  { key: "rejected", label: "Rejected" },
];

const statusBadge = {
  pending: "bg-[#FFF4DE] text-[#B5760C] border border-[#F4D8A0]",
  approved: "bg-[#E5F6EC] text-[#1E8A4C] border border-[#B9E6CB]",
  rejected: "bg-[#FCEAEA] text-[#C23A3A] border border-[#F3C6C6]",
  suspended: "bg-[#F1F0FB] text-[#5B4FC4] border border-[#D8D4F0]",
};

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

const AdminDashboard = () => {
  const navigate = useNavigate();
  const admin = JSON.parse(localStorage.getItem("adminInfo") || "{}");

  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    approved: 0,
    suspended: 0,
    rejected: 0,
  });
  const [schools, setSchools] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
  const [activeTab, setActiveTab] = useState("pending");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedSchoolId, setSelectedSchoolId] = useState(null);

  // Suspend / Reactivate confirmation state
  const [confirmAction, setConfirmAction] = useState(null); // { school, type: 'suspend' | 'reactivate' }
  const [suspendReason, setSuspendReason] = useState("");
  const [actionLoading, setActionLoading] = useState(false);

  const handleAuthError = useCallback(() => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminInfo");
    toast.error("Session expired, please sign in again");
    navigate("/admin/login");
  }, [navigate]);

  const fetchStats = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/v1/admin/stats`, { headers: authHeaders() });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) return handleAuthError();
      if (data.success) setStats(data.stats);
    } catch (error) {
      console.error(error);
    }
  }, [handleAuthError]);

  const fetchSchools = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ status: activeTab, search, page, limit: 10 });
      const res = await fetch(`${BACKEND_URL}/api/v1/admin/schools?${params}`, {
        headers: authHeaders(),
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) return handleAuthError();
      if (data.success) {
        setSchools(data.schools);
        setPagination({ page: data.pagination.page, totalPages: data.pagination.totalPages });
      }
    } catch (error) {
      toast.error("Failed to load school registrations");
    } finally {
      setLoading(false);
    }
  }, [activeTab, search, handleAuthError]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  useEffect(() => {
    const timeout = setTimeout(() => fetchSchools(1), 300); // debounce search
    return () => clearTimeout(timeout);
  }, [fetchSchools]);

  const refreshAll = () => {
    fetchStats();
    fetchSchools(pagination.page);
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminInfo");
    navigate("/admin/login");
  };

  const closeConfirmModal = () => {
    setConfirmAction(null);
    setSuspendReason("");
  };

  const handleSuspend = async (schoolId, reason) => {
    setActionLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/v1/admin/schools/${schoolId}/suspend`, {
        method: "PATCH",
        headers: authHeaders(),
        body: JSON.stringify({ reason }),
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) return handleAuthError();
      if (data.success) {
        toast.success("School suspended");
        refreshAll();
      } else {
        toast.error(data.message || "Failed to suspend school");
      }
    } catch (error) {
      toast.error("Failed to suspend school");
    } finally {
      setActionLoading(false);
      closeConfirmModal();
    }
  };

  const handleReactivate = async (schoolId) => {
    setActionLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/v1/admin/schools/${schoolId}/reactivate`, {
        method: "PATCH",
        headers: authHeaders(),
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) return handleAuthError();
      if (data.success) {
        toast.success("School reactivated");
        refreshAll();
      } else {
        toast.error(data.message || "Failed to reactivate school");
      }
    } catch (error) {
      toast.error("Failed to reactivate school");
    } finally {
      setActionLoading(false);
      closeConfirmModal();
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#F5F8FC]" style={bodyFont}>
      <div className="bg-white border-b border-[#EDF1F7] sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div>
            <h1 style={displayFont} className="text-xl text-[#101826]">
              Eduvantra Admin Console
            </h1>
            <p className="text-xs text-[#5A6478]">School registration & approvals</p>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-[#5A6478]">{admin?.name}</span>
            <button
              onClick={logout}
              className="flex items-center gap-1.5 text-sm text-[#C23A3A] hover:text-[#9c2f2f] transition-colors"
            >
              <BiLogOut /> Logout
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
          {[
            { label: "Total Registrations", value: stats.total, color: "#163863" },
            { label: "Pending Review", value: stats.pending, color: "#B5760C" },
            { label: "Approved", value: stats.approved, color: "#1E8A4C" },
            { label: "Suspended", value: stats.suspended, color: "#5B4FC4" },
            { label: "Rejected", value: stats.rejected, color: "#C23A3A" },
          ].map((card) => (
            <div
              key={card.label}
              className="bg-white rounded-2xl border border-[#EDF1F7] p-5 shadow-[0_1px_2px_rgba(16,24,38,0.04)]"
            >
              <p className="text-xs text-[#5A6478] mb-2">{card.label}</p>
              <p style={{ ...displayFont, color: card.color }} className="text-3xl">
                {card.value}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-[#EDF1F7] p-4 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex flex-wrap gap-2">
              {STATUS_TABS.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    activeTab === tab.key
                      ? "bg-[#163863] text-white"
                      : "bg-[#F5F8FC] text-[#5A6478] hover:bg-[#EEF3FC]"
                  }`}
                >
                  {tab.label}
                  {tab.key === "pending" && stats.pending > 0 && (
                    <span className="ml-1.5 inline-flex items-center justify-center text-[11px] bg-[#E8A63C] text-white rounded-full w-4 h-4">
                      {stats.pending}
                    </span>
                  )}
                  {tab.key === "suspended" && stats.suspended > 0 && (
                    <span className="ml-1.5 inline-flex items-center justify-center text-[11px] bg-[#5B4FC4] text-white rounded-full w-4 h-4">
                      {stats.suspended}
                    </span>
                  )}
                </button>
              ))}
            </div>

            <div className="flex items-center gap-2">
              <div className="relative">
                <BiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A6AFBD]" />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search by name, school ID, email, city..."
                  className="pl-9 pr-4 py-2 w-72 bg-white border border-[#E3E8F0] rounded-full text-sm outline-none focus:border-[#2E63B8] focus:shadow-[0_0_0_4px_rgba(46,99,184,0.12)] transition-all"
                />
              </div>
              <button
                onClick={refreshAll}
                title="Refresh"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#E3E8F0] text-[#5A6478] hover:bg-[#F5F8FC] transition-colors"
              >
                <BiRefresh className="text-lg" />
              </button>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-[#EDF1F7] overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#F8FAFD] text-left text-[#5A6478] text-xs uppercase tracking-wide">
                <th className="px-5 py-3 font-medium">School</th>
                <th className="px-5 py-3 font-medium">School ID</th>
                <th className="px-5 py-3 font-medium">Location</th>
                <th className="px-5 py-3 font-medium">Submitted</th>
                <th className="px-5 py-3 font-medium">Status</th>
                <th className="px-5 py-3 font-medium text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="px-5 py-10 text-center text-[#A6AFBD]">
                    Loading registrations...
                  </td>
                </tr>
              ) : schools.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-5 py-10 text-center text-[#A6AFBD]">
                    No registrations found
                  </td>
                </tr>
              ) : (
                schools.map((school) => (
                  <tr
                    key={school._id}
                    className="border-t border-[#EDF1F7] hover:bg-[#F8FAFD] transition-colors"
                  >
                    <td className="px-5 py-3.5">
                      <p className="text-[#101826] font-medium">{school.name}</p>
                      <p className="text-xs text-[#A6AFBD]">{school.email}</p>
                    </td>
                    <td className="px-5 py-3.5 text-[#5A6478]">{school.schoolId}</td>
                    <td className="px-5 py-3.5 text-[#5A6478]">
                      {school.city}, {school.state}
                    </td>
                    <td className="px-5 py-3.5 text-[#5A6478]">
                      {new Date(school.createdAt).toLocaleDateString("en-IN", {
                        day: "2-digit", month: "short", year: "numeric",
                      })}
                    </td>
                    <td className="px-5 py-3.5">
                      <span className={`px-2.5 py-1 rounded-full text-xs font-medium capitalize ${statusBadge[school.status]}`}>
                        {school.status}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-right">
                      <div className="flex items-center justify-end gap-2">
                        <button
                          onClick={() => setSelectedSchoolId(school._id)}
                          className="px-4 py-1.5 rounded-full border border-[#2E63B8] text-[#2E63B8] text-xs font-semibold hover:bg-[#2E63B8] hover:text-white transition-colors"
                        >
                          Review
                        </button>
                        {school.status === "approved" && (
                          <button
                            onClick={() => setConfirmAction({ school, type: "suspend" })}
                            className="px-4 py-1.5 rounded-full border border-[#5B4FC4] text-[#5B4FC4] text-xs font-semibold hover:bg-[#5B4FC4] hover:text-white transition-colors"
                          >
                            Suspend
                          </button>
                        )}
                        {school.status === "suspended" && (
                          <button
                            onClick={() => setConfirmAction({ school, type: "reactivate" })}
                            className="px-4 py-1.5 rounded-full border border-[#1E8A4C] text-[#1E8A4C] text-xs font-semibold hover:bg-[#1E8A4C] hover:text-white transition-colors"
                          >
                            Reactivate
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {pagination.totalPages > 1 && (
          <div className="flex justify-center gap-2 mt-6">
            {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                onClick={() => fetchSchools(p)}
                className={`w-8 h-8 rounded-full text-sm ${
                  pagination.page === p
                    ? "bg-[#163863] text-white"
                    : "bg-white border border-[#E3E8F0] text-[#5A6478] hover:bg-[#F5F8FC]"
                }`}
              >
                {p}
              </button>
            ))}
          </div>
        )}
      </div>

      {selectedSchoolId && (
        <SchoolReviewModal
          schoolId={selectedSchoolId}
          onClose={() => setSelectedSchoolId(null)}
          onActionComplete={() => {
            setSelectedSchoolId(null);
            refreshAll();
          }}
        />
      )}

      {confirmAction?.type === "suspend" && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" style={bodyFont}>
          <div className="bg-white rounded-2xl p-6 w-full max-w-md">
            <h3 style={displayFont} className="text-lg text-[#101826] mb-2">
              Suspend {confirmAction.school.name}?
            </h3>
            <p className="text-sm text-[#5A6478] mb-4">
              This will immediately block the school's login access. Provide a reason (sent to the school by email).
            </p>
            <textarea
              value={suspendReason}
              onChange={(e) => setSuspendReason(e.target.value)}
              placeholder="Reason for suspension..."
              className="w-full border border-[#E3E8F0] rounded-lg p-3 text-sm mb-4 outline-none focus:border-[#2E63B8]"
              rows={3}
              autoFocus
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={closeConfirmModal}
                disabled={actionLoading}
                className="px-4 py-2 rounded-full text-sm text-[#5A6478] hover:bg-[#F5F8FC] disabled:opacity-40"
              >
                Cancel
              </button>
              <button
                disabled={!suspendReason.trim() || actionLoading}
                onClick={() => handleSuspend(confirmAction.school._id, suspendReason)}
                className="px-4 py-2 rounded-full text-sm bg-[#5B4FC4] text-white disabled:opacity-40"
              >
                {actionLoading ? "Suspending..." : "Confirm Suspend"}
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmAction?.type === "reactivate" && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" style={bodyFont}>
          <div className="bg-white rounded-2xl p-6 w-full max-w-md">
            <h3 style={displayFont} className="text-lg text-[#101826] mb-2">
              Reactivate {confirmAction.school.name}?
            </h3>
            <p className="text-sm text-[#5A6478] mb-4">
              This restores full login access for the school immediately.
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={closeConfirmModal}
                disabled={actionLoading}
                className="px-4 py-2 rounded-full text-sm text-[#5A6478] hover:bg-[#F5F8FC] disabled:opacity-40"
              >
                Cancel
              </button>
              <button
                onClick={() => handleReactivate(confirmAction.school._id)}
                disabled={actionLoading}
                className="px-4 py-2 rounded-full text-sm bg-[#1E8A4C] text-white disabled:opacity-40"
              >
                {actionLoading ? "Reactivating..." : "Confirm Reactivate"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;